import { FormulaType } from '../../constants/formulaType';

import { FormulaDetailModel } from '../../models/formula.model';

export const getDisableTestEmailMessage = (
    formulaType: FormulaType,
    formula: FormulaDetailModel,
) => {
    return {
        isDisable:
            formulaType === FormulaType.email &&
            !formula?.additional_metadata?.from_,
        message: `From field is required`,
    };
};
